const requireComponent = require.context(
    '.',
    true,
    // 匹配所有的 [component]/index.ts[x] 文件，除了 icon/index.tsx
    /(?<!icon)\/index\.tsx?$/
);
const Icon = require('kwai-icon');

function hyphenToPascalCase(fileName) {
    const str = fileName.substring(2).replace(/\/index\.tsx$/, '');
    const camelCase = str.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase();
    });
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
}

module.exports = requireComponent.keys().reduce(
    (accumulator, fileName) => {
        const componentConfig = requireComponent(fileName);

        accumulator[hyphenToPascalCase(fileName)] = componentConfig.default || componentConfig;
        return accumulator;
    },
    { Icon: Icon.default || Icon }
);
